import React from 'react';
import { BookOpen, User, Mic, Briefcase, Award, ShoppingBag, CreditCard } from 'lucide-react';
import type { DashboardTab } from './MemberDashboardClient';

interface Member {
  opportunityMatches: number;
  notificationCount: number;
  coursesEnrolled: number;
}

interface Props {
  activeTab: DashboardTab;
  onTabChange: (tab: DashboardTab) => void;
  member: Member;
}

const tabs: {
  id: DashboardTab;
  label: string;
  icon: React.ElementType;
  badgeKey?: keyof Member;
}[] = [
  { id: 'learning', label: 'My Learning', icon: BookOpen, badgeKey: 'coursesEnrolled' },
  { id: 'profile', label: 'Career Profile', icon: User },
  { id: 'interview', label: 'AI Interview', icon: Mic },
  { id: 'opportunities', label: 'Opportunities', icon: Briefcase, badgeKey: 'opportunityMatches' },
  { id: 'certifications', label: 'Certifications', icon: Award },
  { id: 'marketplace', label: 'Marketplace', icon: ShoppingBag },
  { id: 'payments', label: 'Payments', icon: CreditCard },
];

export default function DashboardTabs({ activeTab, onTabChange, member }: Props) {
  return (
    <div data-component-id="src/app/member-dashboard/components/DashboardTabs.tsx:34:4" data-component-path="src/app/member-dashboard/components/DashboardTabs.tsx" data-component-line="34" data-component-end-line="60" data-component-file="DashboardTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-1%20overflow-x-auto%20scrollbar-thin%20border-b%20border-border%20pb-0%22%7D" className="flex items-center gap-1 overflow-x-auto scrollbar-thin border-b border-border pb-0">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const badge = tab.badgeKey ? member[tab.badgeKey] : undefined;
        return (
          <button data-component-id="src/app/member-dashboard/components/DashboardTabs.tsx:39:10" data-component-path="src/app/member-dashboard/components/DashboardTabs.tsx" data-component-line="39" data-component-end-line="57" data-component-file="DashboardTabs.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={`dash-tab-${tab.id}`}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center gap-2 px-5 py-3.5 text-sm font-semibold rounded-t-xl border border-transparent border-b-0 shrink-0 transition-all duration-200 relative ${
              isActive
                ? 'tab-active border-border bg-card text-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted/40'
            }`}
          >
            <tab.icon data-component-id="src/app/member-dashboard/components/DashboardTabs.tsx:47:12" data-component-path="src/app/member-dashboard/components/DashboardTabs.tsx" data-component-line="47" data-component-end-line="47" data-component-file="DashboardTabs.tsx" data-component-name="tab.icon" data-component-content="%7B%22elementName%22%3A%22tab.icon%22%7D" size={15} />
            {tab.label}
            {badge !== undefined && badge > 0 && (
              <span data-component-id="src/app/member-dashboard/components/DashboardTabs.tsx:50:14" data-component-path="src/app/member-dashboard/components/DashboardTabs.tsx" data-component-line="50" data-component-end-line="52" data-component-file="DashboardTabs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`px-1.5 py-0.5 rounded-full text-xs font-bold ${isActive ? 'bg-primary/20 text-primary' : 'bg-muted text-muted-foreground'}`}>
                {badge}
              </span>
            )}
            {isActive && (
              <span data-component-id="src/app/member-dashboard/components/DashboardTabs.tsx:55:14" data-component-path="src/app/member-dashboard/components/DashboardTabs.tsx" data-component-line="55" data-component-end-line="55" data-component-file="DashboardTabs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20bottom-0%20left-0%20right-0%20h-0.5%20bg-primary%20rounded-t-full%22%7D" className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-t-full" />
            )}
          </button>
        );
      })}
    </div>
  );
}